import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Ocurrió un error";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.message === "string")
    return `${detail.message}: ${(detail.errors || []).map((e) => e.error).join(" | ")}`;
  return JSON.stringify(detail);
}

export const fetcher = (url) => api.get(url).then((r) => r.data);

// Las imágenes externas se sirven por el backend para que el navegador no las bloquee.
export const safeImage = (url) => {
  if (!url) return "";
  if (url.startsWith("/") || url.includes("/api/media/")) return url;
  return `${API}/media/proxy?url=${encodeURIComponent(url)}`;
};
